import React, { useCallback } from 'react';

import { FloatingNav } from 'src/modules/homeownerApp/components/FloatingNav';
import { AbsoluteContainer } from 'src/modules/homeownerApp/components/Layout/AbsoluteContainer';
import {
  alwaysCreateNewProject,
  closeUploadSheetAfterUpload,
} from 'src/modules/homeownerApp/components/UploadImage';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { HomeownerAppMenuNames } from 'src/modules/homeownerApp/providers/HomeownerAppProvider';

export const FloatingNavOverlay = () => {
  const { loggedIn, currentMenu, setCurrentMenu } = useHomeownerAppContext();

  const openUploadSheetFromFloatingNav = useCallback(
    (newProject: boolean = false) => {
      closeUploadSheetAfterUpload(!newProject);
      alwaysCreateNewProject(newProject);
      setCurrentMenu(HomeownerAppMenuNames.UPLOAD_PHOTO);
    },
    [setCurrentMenu],
  );

  if (!loggedIn) return null;

  return (
    <AbsoluteContainer>
      <FloatingNav
        isNavbarDimmed={currentMenu === HomeownerAppMenuNames.PROFILE}
        isProfileFilled={currentMenu === HomeownerAppMenuNames.PROFILE}
        onAddPhotoClick={openUploadSheetFromFloatingNav}
        onAddProjectClick={() => openUploadSheetFromFloatingNav(true)}
        onHomeClick={() => {
          setCurrentMenu(HomeownerAppMenuNames.PROJECT_SELECTION);
        }}
        onProfileClick={() => setCurrentMenu(HomeownerAppMenuNames.PROFILE)}
      />
    </AbsoluteContainer>
  );
};
